import { render } from "./ContactButton.vue?vue&type=template&id=0bca0f60&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=0bca0f60&lang=scss&scoped=true"

import exportComponent from "C:\\OpenServer\\domains\\ar-esqrd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bca0f60"]])

export default __exports__